import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { PendingCollectionService } from '../../../services/pending-collection.service';
import { Router } from '@angular/router';
import { MatTab, MatTabChangeEvent, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'eca-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [MatTabGroup, MatTab, MatTabLabel, AsyncPipe]
})
export class NavComponent implements OnInit, AfterViewInit {
  navigationCollectionService = inject(PendingCollectionService);
  router = inject(Router);


  @ViewChild('navTabGroup')
    tabsComponent: MatTabGroup;
  selectedIndex = 0;
  navLinks: any[];

  ngOnInit(): void {
    this.navLinks = [
      {
        label: 'Scan',
        path: '/scan',
      },
      {
        label: 'Submit',
        path: '/biographics',
        count: this.navigationCollectionService.pendingCount$,
      },
      {
        label: 'Alerts',
        path: '/alerts',
        count: this.navigationCollectionService.alertCount$,
      },
    ];

    const lastUrlSegment = this.router.url.split('?')[0].split('/').pop();

    for (let index = 0; index < this.navLinks.length; index++) {
      if (this.navPathEndsWith(index, lastUrlSegment)) {
        this.selectedIndex = index;
        break;
      }
    }
  }

  navPathEndsWith(index: number, segment: string): boolean {
    return this.navLinks[index].path.endsWith(segment);
  }

  ngAfterViewInit(): void {
    this.tabsComponent.selectedIndex = this.selectedIndex;
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.router.navigate([this.navLinks[event.index].path]).catch(console.log);
  }
}
